import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import Logo from "../components/Logo";

export default function AdminLogin() {
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            const res = await api.post("/admin/login", { password });
            localStorage.setItem("admin_token", res.data.token);
            navigate("/admin", { replace: true });
        } catch (err) {
            setError(err?.response?.data?.detail || "كلمة المرور غير صحيحة");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div data-testid="admin-login-page" className="min-h-[80vh] flex items-center justify-center px-4 py-12">
            <form onSubmit={submit} className="surface-card p-6 sm:p-8 w-full max-w-sm">
                <div className="flex justify-center mb-4">
                    <Logo size={64} />
                </div>
                <h1 className="text-2xl font-black text-text-main text-center">لوحة المدير</h1>
                <p className="text-text-muted text-center text-sm mt-1">أدخل كلمة المرور للدخول</p>

                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    data-testid="admin-password"
                    placeholder="كلمة المرور"
                    className="w-full mt-6 px-4 py-3 bg-[var(--bg)] border-2 border-[var(--border-subtle)] rounded-xl focus:outline-none focus:border-brand"
                />

                {error && (
                    <div data-testid="admin-login-error" className="text-red-600 text-sm mt-3 text-center font-bold">
                        {error}
                    </div>
                )}

                <button
                    type="submit"
                    disabled={loading || !password}
                    data-testid="admin-login-submit"
                    className="btn-brand w-full mt-6 disabled:opacity-50"
                >
                    {loading ? (
                        <><i className="fa-solid fa-spinner fa-spin ms-2" /> جاري الدخول...</>
                    ) : (
                        <><i className="fa-solid fa-right-to-bracket ms-2" /> دخول</>
                    )}
                </button>
            </form>
        </div>
    );
}
